const TicketDetailsPlaceholder = () => {
  return (
    <div className="container mx-auto px-4 py-8 pb-32 md:pb-8">
      <div className="flex flex-col md:flex-row gap-8">
        <div className="flex-1">
          {/* Contact Information Placeholder */}
          <div className="mb-6 p-6 border border-theme_text_light rounded-lg bg-theme_background shadow-sm">
            <div className="h-8 w-48 bg-gray-300 animate-pulse rounded mb-4" />
            <div className="grid grid-cols-2 gap-6">
              {/* Input field placeholders */}
              {[1, 2, 3, 4].map((index) => (
                <div key={index}>
                  <div className="h-4 w-24 bg-gray-300 animate-pulse rounded mb-2" />
                  <div className="h-10 w-full bg-gray-300 animate-pulse rounded" />
                </div>
              ))}
            </div>
          </div>

          {/* Ticket Forms Placeholder */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2].map((ticketIndex) => (
              <div
                key={ticketIndex}
                className="border border-theme_text_light rounded-lg p-6 shadow-sm"
              >
                <div className="h-6 w-32 bg-gray-300 animate-pulse rounded mb-4" />
                <div className="space-y-4">
                  {[1, 2, 3].map((inputIndex) => (
                    <div key={inputIndex}>
                      <div className="h-4 w-24 bg-gray-300 animate-pulse rounded mb-2" />
                      <div className="h-10 w-full bg-gray-300 animate-pulse rounded" />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Desktop Order Summary Placeholder */}
        <div className="hidden md:block w-80">
          <div className="border border-theme_text_light rounded-lg p-6 sticky top-8 shadow-sm">
            <div className="h-6 w-32 bg-gray-300 animate-pulse rounded mb-4" />
            {[1, 2].map((index) => (
              <div key={index} className="flex justify-between mb-2">
                <div className="h-4 w-24 bg-gray-300 animate-pulse rounded" />
                <div className="h-4 w-16 bg-gray-300 animate-pulse rounded" />
              </div>
            ))}
            <div className="mt-4 pt-4 border-t border-theme_text_light">
              <div className="flex justify-between mb-4">
                <div className="h-6 w-20 bg-gray-300 animate-pulse rounded" />
                <div className="h-6 w-24 bg-gray-300 animate-pulse rounded" />
              </div>
              <div className="space-y-3">
                <div className="h-10 w-full bg-gray-300 animate-pulse rounded" />
                <div className="h-10 w-full bg-gray-300 animate-pulse rounded" />
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Order Summary Footer Placeholder */}
        <div className="fixed bottom-0 left-0 right-0 md:hidden border-t border-theme_text_light shadow-lg">
          <div className="container mx-auto p-4">
            <div className="flex justify-between items-center mb-4">
              <div className="h-5 w-20 bg-gray-300 animate-pulse rounded" />
              <div className="h-5 w-24 bg-gray-300 animate-pulse rounded" />
            </div>
            <div className="flex gap-3">
              <div className="flex-1 h-10 bg-gray-300 animate-pulse rounded" />
              <div className="flex-1 h-10 bg-gray-300 animate-pulse rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { TicketDetailsPlaceholder }
